// Publishers type their site the way they say it out loud — "glossyu.com".
// The signup field used to be `type="url"`, so the browser refused exactly that
// with a transient bubble, no inline error, and no submit: the form simply did
// nothing. Accept the bare domain and add the scheme ourselves.
//
// Deliberately NOT a validity regex. The only question that matters is whether
// the URL parses and names a host with a dot in it; anything stricter starts
// rejecting real domains (new TLDs, IDNs, ports on staging sites).
//
// Lives in utils rather than beside the form so it can be unit-tested without
// pulling a component, its context and the router in behind it.
export function normalizeWebsiteUrl(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const parsed = new URL(withScheme);
    if (!parsed.hostname.includes('.')) return null;
    return parsed.toString().replace(/\/$/, '');
  } catch {
    return null;
  }
}
